import React from 'react'
import Parser from 'html-react-parser'
import BEMHelper from '@ynap/bem-helper'
import { Button } from '@ynap/button'

const bem = new BEMHelper('Unsubscribe')

export const ConsentHeader = ({ item }) => {
    const { teaserTitle, subTitle, teaserText } = item

    return (
        <div className={bem('header')}>
            {teaserTitle && <h2 className={bem('header-title')}>{teaserTitle}</h2>}
            {subTitle && <div className={bem('header-subTitle')}>{Parser(subTitle)}</div>}
            {teaserText && <div className={bem('header-teaserText')}>{Parser(teaserText)}</div>}
        </div>
    )
}
ConsentHeader.layoutVariant = 'consent-title'

export const ConsentFooter = ({ item }) => {
    const { teaserText } = item

    return (
        <div className={bem('footer')}>
            {teaserText && <div className={bem('footer-teaserText')}>{Parser(teaserText)}</div>}
        </div>
    )
}
ConsentFooter.layoutVariant = 'consent-footer'

export const ConsentSuccess = ({ item }) => {
    const {
        teaserTitle,
        teaserText,
        target: { teaserTitle: ctaTeaserTitle, href },
    } = item

    return (
        <div className={bem('success-header')}>
            {teaserTitle && <h2 className={bem('success-title')}>{teaserTitle}</h2>}
            {teaserText && <div className={bem('success-teaserText')}>{Parser(teaserText)}</div>}
            {href && (
                <Button type="secondary" className={bem('success-cta')}>
                    <a href={href}>{ctaTeaserTitle}</a>
                </Button>
            )}
        </div>
    )
}
ConsentSuccess.layoutVariant = 'consent-success'
